import React, { useEffect, useState } from 'react';
import { Grid, Tooltip } from '@material-ui/core';
import { HelpOutline } from '@material-ui/icons';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useEnvironment, useSnackbar } from '../../../../hooks';
import MUIDataTable from 'mui-datatables';
import { usePaymentDelayGql } from '../../graphql/payment-delay';
import { IPaymentsDelay } from './interfaces';
import { useStyles } from './styles';

export const PaymentDelay = (props: IPaymentsDelay) => {
  const { args } = props;
  const { runPaymentDelayGql, dataPaymentDelay, errorPaymentDelay, loadingPaymentDelay } = usePaymentDelayGql();
  const { DEBUG } = useEnvironment();
  const { Snackbar, toggleSnackbar } = useSnackbar();
  const classes = useStyles();
  const [totalDaysExtension, setTotalDaysExtension] = useState(0);

  const columns = [
    {
      label: 'ID Prod',
      name: 'productId'
    },
    {
      label: 'Nome Produto',
      name: 'productName'
    },
    {
      label: 'Valor',
      name: 'amountNet'
    },
    {
      label: 'Número Pedido',
      name: 'orderNumber'
    },
    {
      label: 'Agenda Original',
      name: 'originalScheduleDate'
    },
    {
      label: 'Prorrogação do Produto',
      name: 'delayPaymentTerm'
    },
    {
      label: 'Prorrogação Final',
      name: 'proportionalDelayTerm',
      options: {
        customBodyRender: (value: number) => <div style={{ textAlign: 'center' }}>{value.toFixed(3)}</div>
      }
    }
  ];

  const handleLoadData = async (args: IPaymentsDelay['args']) => {
    const { invoiceNumber, invoiceSerieDescription, invoiceSubSerieNumber, issueDate, personId } = args;
    runPaymentDelayGql({
      variables: {
        invoiceNumber,
        invoiceSerieDescription,
        invoiceSubSerieNumber,
        issueDate,
        personId
      }
    });
  };

  useEffect(() => {
    handleLoadData(args);
  }, []);

  useEffect(() => {
    let total = 0;
    dataPaymentDelay.map((delay) => (total += delay.proportionalDelayTerm));
    setTotalDaysExtension(Math.round(total));
  }, [dataPaymentDelay]);

  useEffect(() => {
    if (errorPaymentDelay) {
      if (DEBUG === 'TRUE') {
        console.log(`Erro ao carregar dados! Error:(message: ${errorPaymentDelay} )`);
      } else {
        toggleSnackbar({
          message: 'Ocorreu um problema ao carregar os dados. Por favor, informe ao suporte.',
          type: 'error'
        });
      }
    }
  }, [errorPaymentDelay]);

  const Table = () => {
    return (
      <>
        <MUIDataTable
          title=""
          data={dataPaymentDelay}
          columns={columns}
          options={{
            textLabels: {
              body: {
                noMatch: 'Sorry, no matching records found',
                toolTip: 'Sort',
                columnHeaderTooltip: (column) =>
                  column.label === 'Prorrogação Final'
                    ? 'Cálculo feito por meio da média ponderada entre a Prorrogação do Produto, o Valor do produto e o valor total da NF'
                    : 'Ordenar'
              }
            },
            print: false,
            filter: false,
            download: false,
            search: false,
            viewColumns: false,
            selectableRows: 'none',
            responsive: 'simple',
            pagination: dataPaymentDelay.length > 5 ? true : false,
            rowsPerPage: 4
          }}
        />

        <Grid container direction="row" justifyContent="flex-end">
          <Grid item xs={2}>
            <Tooltip title={'Total Prorrogação Final em dias'} arrow>
              <div
                style={{
                  backgroundColor: 'lightgray',
                  textAlign: 'center',
                  padding: '5px',
                  borderRadius: '0px 0px 0px 5px',
                  fontWeight: 'bolder',
                  fontSize: '15px'
                }}
              >
                Total &nbsp;
                <HelpOutline style={{ fontSize: '13px' }} />
              </div>
            </Tooltip>
          </Grid>
          <Grid item xs={1}>
            <div style={{ padding: '5px' }}>{totalDaysExtension}</div>
          </Grid>
        </Grid>
      </>
    );
  };

  return (
    <>
      <Snackbar />
      {loadingPaymentDelay && (
        <div className={classes.loader}>
          <CircularProgress />
        </div>
      )}
      {!loadingPaymentDelay && <Table />}
    </>
  );
};
